export const columns = [
  {
    header: "Name",
    accessorKey: "name",
  },
]
